/* eslint-disable */
import '@babel/polyfill';
/* eslint-disable */
import ESPromise from 'es6-promise';
import VueI18n from 'vue-i18n';
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store/index';
import enLocale2 from './lang/en';
import znLocale2 from './lang/cn';
import './util/ant-ui';
import './util/custom-directives';
import './util/custom-filters';
import './assets/styles/postcss/index.css';
import * as oauth from './util/oauth';

ESPromise.polyfill();
Vue.config.productionTip = false;
Vue.use(VueI18n);

const messages = {
    en: {
        ...enLocale2
    },
    cn: {
        ...znLocale2
    }
};
const i18n = new VueI18n({ // 国际化
    locale: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'cn',
    messages
});

const options = {
    returnTo: `${window.location.protocol}//${window.location.host}`,
    clientId: process.env.VUE_APP_ClientId,
    provider: process.env.VUE_APP_Provider
};
store.commit('setI18N', i18n);
store.commit('setRouter', router);
store.commit('setPublicComponent', Vue.prototype);

const createIns = () => {
    const instance = new Vue({ // 初始化application
        router,
        store,
        i18n,
        render: h => h(App),
    });
    instance.$on('vueBeginCreate', (callBack) => {
        instance.$off('vueBeginCreate');
        instance.$destroy();
        window.zxyVue = createIns();
        callBack();
        callBack = null;
    });
    return instance;
};
const setup = () => {
    // console.log('启动VueAPP');
    oauth.initOauth(store.state.app).then((res) => {
        oauth.setOauth(store.state.app, options, res); // 设置登录相关的token
        store.commit('setOauth'); // 设置登录相关的token和http全局参数
        window.zxyVue = createIns();
    });
};

export default { setup };
